import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountyRoutingModule } from './county-routing.module';
import { CountyComponent } from './county.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { CreateCountyComponent } from './components/create-county/create-county.component';
import { DirectivesModule } from '../../directives/directives.module';
import { CountyService } from '../../services/county.service';
import { AddZipCodeComponent } from './add-zip-code/add-zip-code.component';
import { CountyHelper } from 'app/core/helpers/county-helper.service';

@NgModule({
  imports: [
    CommonModule,
    AgGridModule.withComponents([BooleanCheckComponent]),
    GridComponentsModule,
    FormsModule,
    CountyRoutingModule,
    Trip2ThemeModule,
    DirectivesModule,
    ReactiveFormsModule,
  ],
  declarations: [CountyComponent, CreateCountyComponent, AddZipCodeComponent],
  providers: [CountyService, CountyHelper],
})
export class CountyModule {}



// WEBPACK FOOTER //
// ./src/app/pages/county/county.module.ts